import { DesignTokens, useTheme } from '@gousto-internal/citrus-react';

export function useTypographyTokens(kind: keyof DesignTokens['typographyDefaults']) {
  const { theme } = useTheme();
  return theme.tokens.typographyDefaults[kind];
}
